$gap: 2em;
$gap-small: 1em;
$left-flex: 2;
$right-flex: 1;

.agreementDetailsWrapper {
  display: flex;
  flex-direction: column;
  gap: $gap-small;

  .row {
    display: flex;
    width: 100%;
    gap: $gap;
    justify-content: space-between;

    .navnField {
      flex: $left-flex;
    }

    .saksnrField {
      flex: $right-flex;
    }

    .datoFields {
      display: flex;
      gap: $gap;
      flex: $left-flex;

      .datoField {
        width: 100%;
      }
    }

    .ansvarligField {
      flex: $right-flex;
    }
  }
}
